import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { FieldAnswerFeedback } from '../../ui/field-answer-feedback/field-answer-feedback';
import { shuffle } from 'lodash';
import { FIELD_TYPES } from '../../constants';
import { RadioGroupComponent } from '../../ui/radio-group/radio-group-component';
import FieldWrapper from '../../ui/field-wrapper';
const QuizSingleChoice = props => {
  const {
    target,
    options = [],
    randomizeChoices,
    externalData
  } = props;
  const sortedOptions = useMemo(() => randomizeChoices ? shuffle(options) : options, [options, randomizeChoices]);
  return /*#__PURE__*/React.createElement(FieldWrapper, {
    fieldType: FIELD_TYPES.QUIZ_SINGLE_CHOICE,
    dataHook: target
  }, /*#__PURE__*/React.createElement(RadioGroupComponent, _extends({}, props, {
    options: sortedOptions,
    fieldType: FIELD_TYPES.QUIZ_SINGLE_CHOICE,
    required: false
  })), /*#__PURE__*/React.createElement(FieldAnswerFeedback, {
    target: target,
    externalData: externalData
  }));
};
export default QuizSingleChoice;
//# sourceMappingURL=quiz-single-choice.js.map